<form [formGroup]="formGroup">
    <div class="modal-header">
        @if (type === 'address') {
            <h5 class="modal-title">
                {{ 'reporting_CHANGE_ADMINISTRATOR_INFO' | translate }}
            </h5>
        }
        @if (type === 'billingAddress') {
            <h5 class="modal-title">
                {{ 'reporting_BILLING_ADDRESS_INFO' | translate }}
            </h5>
        }
        <button
            type="button"
            class="btn-close"
            aria-label="Close"
            (click)="activeModal.dismiss('Cancel')"></button>
    </div>

    <div class="modal-body">
        <app-input-text-group [label]="'reporting_NAME' | translate" formControlName="name" />
        <app-input-text-group
            [label]="'common_ADDRESS' | translate: 'online' : 'common'"
            formControlName="address1" />
        <div class="mb-3">
            <app-input-text-group formControlName="address2" />
        </div>
        <app-country-postal-code-city [formControl]="formGroup.controls.countryAndPostalCode" />
    </div>

    <div class="modal-footer">
        <button class="btn btn-primary" (click)="activeModal.dismiss('Cancel')">
            {{ 'reporting_CANCEL' | translate }}
        </button>
        <button class="btn btn-primary" (click)="submit()">
            {{ 'reporting_SAVE' | translate }}
        </button>
    </div>
</form>
